module.exports = __webpack_public_path__ + "static/img/5.40cd72c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5.jpg
// module id = 2BgX
// module chunks = 26